import { RefObject, useEffect, useState } from 'react';

export const useWidth = (containerRef: RefObject<HTMLElement | null>, recalculateKey?: unknown) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.getBoundingClientRect().width);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [containerRef, recalculateKey]);

  return { width, setWidth };
};
